export default "__VITE_ASSET__682a32d7__"